import { RibbonLabel, RibbonLabelProps } from './RibbonLabel';

interface RibbonContainerProps {
  ribbons: RibbonLabelProps[];
  isMobile?: boolean;
}

export const RibbonContainer: React.FC<RibbonContainerProps> = ({
  ribbons,
  isMobile,
}) => {
  const ribbonsContainerClass = isMobile ? 'flex-col mt-2' : 'flex-row mt-7';

  const lastRibbonIndex = ribbons.length - 1;

  return (
    <div
      className={`absolute left-0 uppercase z-40 flex ${ribbonsContainerClass}`}
      style={{
        alignItems: isMobile ? 'flex-start' : 'center',
      }}
    >
      {ribbons.map((ribbon, index) => {
        let forcedType: RibbonLabelProps['type'];
        if (index === 0) {
          forcedType = 'golden';
        } else if (index === 1) {
          forcedType = 'white';
        } else {
          forcedType = 'golden';
        }
        return (
          <RibbonLabel
            key={index}
            label={ribbon.label}
            type={forcedType}
            width={ribbon.width}
            isUnitPreconstruction={ribbon.isUnitPreconstruction}
            statusCode={ribbon.statusCode}
            className={ribbon.className}
            color={ribbon.color}
            isRibbonLast={index === lastRibbonIndex}
            isMobile={isMobile}
          />
        );
      })}
    </div>
  );
};
